import React, { Fragment } from 'react';
import Select from '4all-ui/components/Select';
import Input from '4all-ui/components/Input';
import InputCurrency from '4all-ui/components/InputCurrency';
import Textarea from '4all-ui/components/Textarea';
import * as styles from './style';
import { Box, TitleBox, FormGroupCol, Row } from '../../styles/customComponents';
import ImageUpload from '../../components/ImageUpload';
import FormFooter from '../../components/FormFooter';
import FormLoader from '../../components/FormLoader';
import withCreateProduct from '../../containers/CreateProduct';
import SelectProductAddons from '../../components/SelectProductAddons';
import ProductAddons from '../../components/ProductAddons';
import { PRODUCT_ADDONS_TYPE } from '../../helpers/constants';
import withCreateProductAddons from '../../containers/CreateProductsAddons';
import VariationDragDrop from '../../components/VariationDragDrop';
import SelectTagList from '../../components/SelectTagList';

const CreateProduct = ({
  productCategories,
  history,
  isSubmitting,
  data,
  errors,
  getError,
  showSubmitLoader,
  closeFormModal,
  closeFormErrorModal,
  onChangeFile,
  handleChange,
  handleChangePrice,
  handleSelectCategory,
  onSelectAddonType,
  clearAddonType,
  clearAllSteps,
  addonType,
  onSubmit,
  productRequestError,
  isLoadingEdit,
  tags,
  apiErrors,
  toggleTag,
}) => {
  const { list: categories, isLoading: isLoadingCategories } = productCategories;

  let serializedCategories = [];
  if (categories.length) {
    serializedCategories = categories.map(cat => ({
      id: cat.id,
      label: cat.name,
      value: cat.id,
    }));
  }

  const clearAddons = () => {
    clearAllSteps();
    clearAddonType();
  };

  const getCategoryPlaceholder = () => {
    if (apiErrors.errorCategories.message) {
      return apiErrors.errorCategories.message;
    }
    if (isLoadingCategories) {
      return 'Carregando ...';
    }

    return 'Selecione a categoria';
  };

  const getCategorySelectCursor = () => {
    if (apiErrors.errorCategories.message) {
      return 'not-allowed';
    }
    if (isLoadingCategories) {
      return 'progress';
    }
    return 'default';
  };

  const currentError = getError();
  const isLoadingProductData = isLoadingEdit();
  return (
    <Fragment>
      <FormLoader
        onClose={productRequestError ? closeFormErrorModal : closeFormModal}
        isSubmiting={isSubmitting || isLoadingProductData}
        showModal={showSubmitLoader || isLoadingProductData}
        error={productRequestError || {}}
        finishedText={isLoadingProductData ? null : 'Produto cadastrado com sucesso!'}
        loadingText={
          isLoadingProductData ? 'Buscando dados do produto ...' : 'Salvando Produto ...'
        }
      />
      {!isLoadingProductData && (
        <styles.Container>
          <styles.Content>
            <styles.Title>Cadastrar Produto</styles.Title>
            <styles.BoxContent>
              <Box size={8}>
                <TitleBox>Informações do Produto</TitleBox>
                <styles.FieldsContainer>
                  <ImageUpload
                    id="inp-voucher-image"
                    fileUrl={data.media.imageBase64}
                    file={data.media.file}
                    width="150px"
                    height="150px"
                    onChangeFile={file => onChangeFile(file)}
                  />
                  <styles.Fields>
                    <Row>
                      <FormGroupCol>
                        <label htmlFor="inp-product-name">Nome</label>
                        <Input
                          id="inp-product-name"
                          name="name"
                          onChange={handleChange}
                          value={data.name}
                          error={errors.name.isInvalid}
                        />
                      </FormGroupCol>
                    </Row>
                    <Row
                      styles={{
                        marginTop: '20px',
                      }}
                    >
                      <FormGroupCol width="20%">
                        <label htmlFor="inp-product-price">Preço</label>
                        <InputCurrency
                          id="inp-product-price"
                          name="originalPrice"
                          onChange={handleChangePrice}
                          value={data.originalPrice}
                        />
                      </FormGroupCol>
                      <FormGroupCol
                        width="50%"
                        styles={{
                          paddingLeft: '20px',
                        }}
                      >
                        <label htmlFor="dropdown-product-category">Categoria</label>
                        <Select
                          id="dropdown-product-category"
                          value={data.category}
                          onChange={handleSelectCategory}
                          options={serializedCategories}
                          height="45px"
                          placeholder={getCategoryPlaceholder()}
                          disabled={isLoadingCategories || !!apiErrors.errorCategories.message}
                          error={errors.category.isInvalid || !!apiErrors.errorCategories.message}
                          closeMenuOnSelect
                          containerCustomStyles={{
                            cursor: getCategorySelectCursor(),
                            pointerEvents: 'initial !important',
                          }}
                        />
                      </FormGroupCol>
                      <FormGroupCol
                        width="30%"
                        styles={{
                          paddingLeft: '20px',
                        }}
                      >
                        <label htmlFor="inp-product-sku">Cód. Produto</label>
                        <Input
                          id="inp-product-sku"
                          name="sku"
                          onChange={handleChange}
                          value={data.sku}
                        />
                      </FormGroupCol>
                    </Row>
                    <Row
                      styles={{
                        marginTop: '20px',
                      }}
                    >
                      <FormGroupCol>
                        <label htmlFor="inp-product-barcode">Código de barras</label>
                        <Input
                          id="inp-product-barcode"
                          name="barcode"
                          onChange={handleChange}
                          value={data.barcode}
                        />
                      </FormGroupCol>
                    </Row>
                    <Row
                      styles={{
                        marginTop: '20px',
                      }}
                    >
                      <FormGroupCol>
                        <label htmlFor="inp-product-desc">Descrição</label>
                        <Textarea
                          id="inp-product-desc"
                          name="desc"
                          rows="4"
                          onChange={handleChange}
                          value={data.desc}
                        />
                      </FormGroupCol>
                    </Row>
                  </styles.Fields>
                </styles.FieldsContainer>
              </Box>
              <Box size={4} customStyles={{ paddingBottom: '10px' }}>
                <SelectTagList
                  tags={tags}
                  error={apiErrors.errorTag}
                  selectedTags={data.tags}
                  onToggle={toggleTag}
                />
              </Box>
            </styles.BoxContent>
            <SelectProductAddons
              onSelectType={onSelectAddonType}
              clearAddonType={clearAddons}
              type={addonType}
            />
          </styles.Content>
          {addonType &&
            (addonType === PRODUCT_ADDONS_TYPE.PRODUCTS ? (
              <ProductAddons errorSteps={errors.comboSteps} />
            ) : (
              <VariationDragDrop />
            ))}
          <FormFooter
            cancelAction={() => history.goBack()}
            textSubmit="Salvar Produto"
            errorMessage={currentError ? currentError.message : null}
            nextAction={onSubmit}
          />
        </styles.Container>
      )}
    </Fragment>
  );
};

export default withCreateProductAddons(withCreateProduct(CreateProduct));



// WEBPACK FOOTER //
// ./src/screens/CreateProduct/index.js